import {ChangeEvent} from 'react';
import {FormikHelpers} from 'formik';

export interface FileUploadModalValues {
  files: File[];
}

export const handleFileEvent = ({
  event,
  setFieldValue,
}: {
  event: ChangeEvent<HTMLInputElement>;
  setFieldValue: FormikHelpers<FileUploadModalValues>['setFieldValue'];
}) => {
  if (!event?.target?.files) {
    return;
  }

  // event.target.files is a FileList object that looks like an array but isn't one
  // iterating over the object values to populate a regular JS array here
  const newFiles = [];
  for (let index = 0; index < event.target.files.length; index += 1) {
    newFiles.push(event.target.files[index]);
  }
  setFieldValue('files', newFiles);
};

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64arr = String(reader.result).split('base64,');
      if (base64arr.length !== 2) {
        return reject();
      }
      return resolve(base64arr[1]);
    };
    reader.onerror = reject;
  });

interface downloadBase64FileType {
  contentBase64: string;
  contentType: string;
  fileName: string;
}

// https://stackoverflow.com/questions/16996319/javascript-save-base64-string-as-file
export function downloadBase64File({
  contentType,
  contentBase64,
  fileName,
}: downloadBase64FileType) {
  const linkSource = `data:${contentType};base64,${contentBase64}`;
  const downloadLink = document.createElement('a');
  document.body.appendChild(downloadLink);

  downloadLink.href = linkSource;
  downloadLink.target = '_self';
  downloadLink.download = fileName;
  downloadLink.click();
}
